<template>
  <v-dialog persistent width="500" v-model="dialog">
    <v-card>
      <v-card-title class="headline" primary-title>
        {{$t('department.edit')}}
      </v-card-title>

      <v-form v-model="valid" ref="teamCreateForm">
        <v-card-text>
          <v-text-field
              v-model="name"
              :label="`${$t('team.name')}`"
              :rules="nameRules"
              required
          ></v-text-field>
          <v-checkbox v-model="assignHidden" :label="`${$t('team.create.assign_hidden')}`"></v-checkbox>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-progress-circular
              indeterminate
              color="primary"
              v-if="loading"
              spacing="pr-4"
          ></v-progress-circular>
          <v-btn color="primary" @click="update" :disabled="loading">
            {{ $t('base.ok') }}
          </v-btn>
          <v-btn color="primary" @click="$emit('exit')" :disabled="loading">
            {{ $t('base.cancel') }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  props:['editData','dialog'],
  computed: {
    teams() {
      return this.$store.state.teams
    },
  },
  data() {
    return {
      name: "",
      assignHidden: false,
      loading: false,
      valid: false,
      nameRules: [
        (v) => !!v || this.$t('team.create.error.no-name-msg'),
        (v) => /[A-ZĄĆĘŁŃÓŚŹŻ]/.test(v.charAt(0).toUpperCase()) || this.$t('team.create.error.first-letter-msg'),
        (v) => v.length > 2 || this.$t('team.create.error.min-length-3'),
      ]
    }
  },
  methods: {
    update(){
      if(this.$refs.teamCreateForm.validate()) {
        this.loading = true
        this.$store.dispatch("updateTeam", {
          'id': this.id,
          "name": this.name,
          "assign_hidden": this.assignHidden ? 1 : 0
        }).then(() => {
          this.$store.commit("setSnack", {
            message: 'Ok',
            color: "success"
          })
          this.$refs.teamCreateForm.reset()
          this.$emit("exit")
        }).finally(() => {
          this.loading = false
        })
      }
    },
  },
  watch:{
    'editData': function (){
      if (this.editData) {
        this.id = this.editData.id
        this.name = this.editData.name
        this.assignHidden = this.editData.assign_hidden
      }
    }
  }
}

</script>

<style scoped>
</style>
